import { useCallback } from 'react';
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';

import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

export function useNavigateToRoute() {
  const navigateReactRouter = useReactRouterNavigate();
  const navigate = useCallback(
    (...args: Parameters<typeof getCompletePathFromRouteKey>) => {
      // Returns react-router v7's `void | Promise<void>`: under a data router
      // this resolves once the navigation completes, so callers may await it.
      // Callers that don't care can discard it with `void`.
      return navigateReactRouter(getCompletePathFromRouteKey(...args));
    },
    [navigateReactRouter]
  );

  return { navigate };
}
